import { FormField } from '@/components/ui/form'
import { TimePicker } from '@/components/ui/time-picker'
import { useContext } from 'react'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { FormEntityContext } from '../../config/context/forms'
import FieldWrapper from './FieldWrapper'
import { FieldProps } from './types'
import { cn } from '@/lib/utils'

const normalizeTime = (value: string) => {
  const split = value.split(':')
  const hour = `${parseInt(split[0] ?? '0', 10) || 0}`.padStart(2, '0')
  const minute = `${parseInt(split[1] ?? '0', 10) || 0}`.padStart(2, '0')
  return `${hour}:${minute}`
}

const TimeField = ({
  name,
  className,
  customLabel,
  customDescription,
  layout = 'stacked',
  onChange,
}: FieldProps<string>) => {
  const form = useFormContext()
  const { i18n, t } = useTranslation()
  const { entityType, i18nPrefix } = useContext(FormEntityContext)

  const description =
    customDescription ??
    (i18n.exists(`${i18nPrefix}.${entityType}.${name}.description`)
      ? t(`${i18nPrefix}.${entityType}.${name}.description`)
      : undefined)

  return (
    <div className={cn('w-full', className)}>
      <FormField
        control={form.control}
        name={name}
        render={({ field }) => (
          <FieldWrapper
            layout={layout}
            label={
              customLabel ?? t(`${i18nPrefix}.${entityType}.${name}.label`)
            }
            description={description}
          >
            <TimePicker
              value={field.value}
              onChange={(value) => {
                const normalized = normalizeTime(value)
                field.onChange(normalized)
                onChange?.(normalized)
              }}
            />
          </FieldWrapper>
        )}
      />
    </div>
  )
}

export default TimeField
